import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

export function useEntitlements() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/entitlements/me");
      setData(data);
    } catch (e) {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const ent = data?.entitlements || {};
  const usage = data?.usage || {};
  const can = (cap) => !!ent[cap];
  const limit = (key) => (ent[key] ?? 0);
  const atLimit = (key, usageKey) => {
    const cap = ent[key];
    if (cap === -1 || cap === undefined) return false;
    return (usage[usageKey] ?? 0) >= cap;
  };
  return { ent, usage, loading, refresh, can, limit, atLimit };
}
